import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import {
  BreadcrumbNavContainerStyled,
  BreadcrumbWrapperStyled,
} from './Breadcrumb.style';

interface BreadcrumbProps {
  data: any;
}

const BreadcrumbSection: React.FC<BreadcrumbProps> = (
  props: BreadcrumbProps
) => {
  const { breadCrumb } = props?.data;

  return (
    <BreadcrumbWrapperStyled>
      <BreadcrumbNavContainerStyled>
        <Breadcrumb lightContrast={true} {...breadCrumb}></Breadcrumb>
      </BreadcrumbNavContainerStyled>
    </BreadcrumbWrapperStyled>
  );
};

export default BreadcrumbSection;
